import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PagamentosEfectuadosLayer from "../components/PagamentosEfectuadosLayer";
import { useTranslation } from "../i18n/I18nContext";

const PagamentosEfectuadosPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("pagamentosEfectuados.breadcrumb")} />
      <PagamentosEfectuadosLayer />
    </MasterLayout>
  );
};

export default PagamentosEfectuadosPage;
